import React, { memo, useMemo } from 'react';
import styles from './Footer.module.css';
import { config } from '../../state/config';

const Footer: React.FC = memo(() => {
  const postTradeInEmail = useMemo(() => {
    return (
      <a href="mailto:online@macroev.com" className="text-white underline">
        online@macroev.com
      </a>
    );
  }, []);

  return (
    <footer className={`${styles.Footer}`} data-testid="Footer">
      <div className="footer-widget text-white p-8">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-3">
              <p>
                <img
                  src={`${config.publicUrl}/img/logos/MACRO-EV-evolution-white.png`}
                  alt="logo_footer"
                  width="209"
                  height="62"
                />
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3">
              <p className="company-address">
                21 Fonthill Business Park
                <br />
                D22 FR82
                <br />
                Dublin 22
                <br />
                Ireland
                <br />
                <br />
                <br />
                Phone: 01 4193120
                <br />
                Email: {postTradeInEmail}
              </p>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3" />
            <div className="col-lg-3 col-md-3 col-sm-3">
              <h6>PRIVACY & LEGAL</h6>
              <p className="company-privacy">
                <strong>This website uses Cookies.</strong> Continued use of the site will be deemed as your acceptance
                of this necessity. By using this website you agree to our{' '}
                <a
                  href="https://www.macroev.com/privacy-policy"
                  target="_blank"
                  className="text-white underline"
                  rel="noreferrer"
                >
                  terms of use and privacy policy
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-copyright text-white">
        <div className="container">
          <p>Copyright &#169; 2023 Macro Evolution Services</p>
        </div>
      </div>
    </footer>
  );
});

export default Footer;